import React from 'react';
import { PropertyPage } from './pages/PropertyPage';
export function App() {
  return <PropertyPage data-id="element-0" />;
}